module.exports = __webpack_public_path__ + "img/investpr.610e0e12.jpg";